import { sumBy } from 'lodash-es'

import type { PagedResponse } from '@fv/models'

export type Page<T> = PagedResponse<T>
export type InfiniteQueryData<T> =
  | {
      pageParams: Array<number | null>
      pages: Page<T>[]
    }
  | undefined

export function flattenPages<T>(pages?: Page<T>[]): T[] {
  return (pages ?? []).flatMap(p => p.data)
}

// Next value used for `skip` param
export function getNextPageParam<T>(
  lastPage?: Page<T>,
  allPages?: Page<T>[],
): number | undefined {
  if (!lastPage?.hasMore) return null
  return sumBy(allPages, p => p.data.length)
}

export function setDataByPage<T>(
  getPageData: (pageData: Page<T>['data']) => Page<T>['data'],
): (prevData: InfiniteQueryData<T>) => InfiniteQueryData<T> {
  return (prevData: InfiniteQueryData<T>) =>
    prevData && {
      ...prevData,
      pages: prevData.pages?.map(p => ({
        ...p,
        data: getPageData(p.data),
      })),
    }
}
